<script lang="ts" setup>
import type { ContentItemTypes } from '~/utils/graphql/graphql'

function getSourceSet(url: string, format: string) {
  if (!url.includes('digitaloceanspaces.com')) return url
  for (const ext of ['jpg', 'jpeg']) {
    if (url.endsWith(ext)) {
      const urlPrefix = url.substring(0, url.lastIndexOf(ext) - 1)
      return urlPrefix + '-small.' + format + ', ' + urlPrefix + '-medium.' + format + ' 2x, ' + urlPrefix + '.' + format + ' 3x'
    }
  }
  return url
}
const props = defineProps<{
  item: ContentItemTypes
  class: string
  pictureClass?: string
  src?: string | undefined
  style?: string | undefined
  lazy?: boolean | undefined
}>()

const url = computed(() => {
  if (props.src) return props.src
  const item = props.item
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!item || !item.media || item.media.length === 0 || item.media[0].sources.length === 0) return null
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return item.media[0].sources[0].url
})
</script>

<template>
  <picture
    v-if="url"
    :class="pictureClass"
  >
    <source
      :srcset="getSourceSet(url, 'webp')"
      type="image/webp"
    >
    <source
      :srcset="getSourceSet(url, 'jpg')"
      type="image/jpeg"
    >
    <img
      :loading="(lazy === undefined || lazy) ? 'lazy' : 'eager'"
      :src="url"
      :alt="item.title"
      :class="(props.class || '') + ' bg-gray-200'"
      :style="props.style || undefined"
    >
  </picture>
  <div
    v-else
    :class="(props.class || '') + ' bg-gray-200'"
    :style="props.style || undefined"
  />
</template>
